import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token as fallback (some browsers block 3rd party cookies)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("bf_session_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
